import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function DeschideCurriculum() {
  const curriculum = [{
    title: 'Vei învăța o meditație care îți aduce instant pacea minții.',
    desc: 'Nu o meditație complicată pe care trebuie să o practici luni de zile ca să simți ceva. O meditație simplă, pe care o faci și simți efectul imediat.'
  }, {
    title: 'Vei primi unelte practice, simple dar pline de forță, pe care le aplici zilnic.',
    desc: 'Nu teorie abstractă, ci instrumente concrete pe care le folosești în fiecare dimineață și care aduc abundența în viața ta pas cu pas.'
  }, {
    title: 'Vei descoperi propoziția win-win și cum să o aplici.',
    desc: 'O unealtă concretă, testată, care te ajută să atragi oportunități și să creezi relații în care ambele părți câștigă. Adrian a folosit-o personal pentru a genera venituri de peste 100.000 de euro.'
  }, {
    title: 'Vei înțelege că abundența nu e doar despre bani.',
    desc: 'E despre a avea din plin pe toate planurile: sănătate bună, relații armonioase, liniște interioară, bani suficienți și împlinire sufletească. Aici înveți să le ai pe toate.'
  }, {
    title: 'Vei învăța să primești fără vinovăție și fără rezistență.',
    desc: 'Mulți oameni sunt buni la a da, dar se blochează când vine vorba de a primi. Aici deblochezi acest tipar și permiți vieții să îți ofere ceea ce meriți.'
  }, {
    title: 'Vei activa fluxul de abundență în viața ta.',
    desc: 'Înțelegi cum funcționează echilibrul dintre a da și a primi și înveți să menții acest flux activ, ca banii, oportunitățile și relațiile bune să vină constant.'
  }];
  return <section className="py-20 lg:py-32 bg-brand-cream relative" data-id="element-1021">
      <div className="max-w-4xl mx-auto px-6" data-id="element-1022">
        <SectionHeading title="Ce vei descoperi în acest curs" data-id="element-1023" />

        <div className="space-y-5 mb-16" data-id="element-1024">
          {curriculum.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="flex gap-4 items-start bg-white p-6 md:p-7 rounded-2xl shadow-sm border border-brand-text/5 hover:shadow-warm transition-shadow" data-id="element-1025">
              <div className="flex-shrink-0 mt-1 w-10 h-10 rounded-full bg-brand-gold/10 flex items-center justify-center" data-id="element-1026">
                <CheckCircle2 className="w-6 h-6 text-brand-gold" data-id="element-1027" />
              </div>
              <div data-id="element-1028">
                <h3 className="font-bold text-lg text-brand-text mb-2" data-id="element-1029">
                  {item.title}
                </h3>
                <p className="text-brand-textSec leading-relaxed" data-id="element-1030">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-1031">
          <CTAButton data-id="element-1032" />
        </motion.div>
      </div>
    </section>;
}